import Layout from '@layouts/layout';
import { authComputed, authMethods } from '@state/helpers';
import { trackUserLoggedOut } from '@utils/analytics/events';

export default {
  page: {
    title: 'Logging out...',
    meta: [{ name: 'description', content: 'Logs out the user' }],
  },
  components: { Layout },
  render: () => {},

  computed: {
    ...authComputed,
  },

  methods: {
    ...authMethods,
  },

  created() {
    const userLoggingOut = this.currentUser;
    this.logOut();
    trackUserLoggedOut(userLoggingOut);
  },
};
